<template>
  <div>
    <el-dialog v-loading="loading.dialog" class="task_model_dialog" top="5vh" center title="关联开发任务" width="95%"
               :before-close="handleClose" :visible.sync="dialogVisible" :append-to-body="true" :close-on-click-modal="false">
      <el-form size="mini" ref="form" :rules="rules" :model="form">
        <div style="display: flex">
          <el-form-item label="开发任务名称" prop="title" :label-width="formLabelWidth">
            <el-input v-model="form.devTaskName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="系统" prop="module" :label-width="formLabelWidth">
            <el-select :style="iptStyle" collapse-tags v-model="form.module" multiple filterable
                       placeholder="请选择系统">
              <el-option v-for="(value, key) in allSelect.TEXTFILTERMODULES" :key="key" :label="value" :value="key" />
            </el-select>
          </el-form-item>
          <el-form-item label="开发人员" prop="user_rd" :label-width="formLabelWidth">
            <el-select autocomplete="off" size="mini" v-model="form.developerId" filterable placeholder="请选择开发人员" clearable>
              <el-option v-for="(key, value)  in allUserList.ALLUSERTYPE3" :key="key" :label="key" :value="value" />
            </el-select>
          </el-form-item>
        </div>
        <div>
          <el-form-item>
            <el-button style="margin-left:60px;letter-spacing: 2px;font-weight: bold;font-size: 12px;" type="primary" @click="formSearch()">查询
            </el-button>
          </el-form-item>
        </div>
      </el-form>
      <div>
        <el-table ref="multipleTable" :data="taskList" border tooltip-effect="dark" style="width: 100%" :stripe="true"
                  highlight-current-row @selection-change="handleSelectionChange"  @row-click="rowselect">
          <el-table-column type="selection" width="55" :selectable="selectable" >
          </el-table-column>
          <el-table-column prop="id" label="ID" width="80" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="name" label="开发任务名称" min-width="120" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="module" label="系统" width="120" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="developerId" label="开发人员" width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <span> {{ scope.row.developerId &&  allUserList.DEVUSER &&
              allUserList.DEVUSER[scope.row.developerId] }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="module" label="状态" width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>待处理</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmChoose">确 定</el-button>
        <el-button type="success" @click="handleClose">取 消</el-button>
      </div>
      <Task v-if="dialogVisibleTask" :dialogVisible='dialogVisibleTask' :hideDialogVisible="handleTaskClose" :formInfo="formTaskInfo" />
    </el-dialog>

  </div>
</template>
<script>
import Task from '@/views/tops/devOps/producerSpace/components/task.vue'
import {mapState} from "vuex";
import {getDevOpsSpaceFindDevelopTaskApi} from "@/server/tops/devOps";

export default {
  components:{Task},
  props: {
    demand_id: {
      default: '',
    },
    taskList: {
      type:Object,
      default: function () {
        return {}
      },
    },
    checkedTestInfo: {
      type:Object,
      default: function () {
        return {}
      },
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
    getChooseTask: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
  },
  data() {
    return {
      tableData: [],
      selectData: [],
      loading: {
        dialog: false,
        submit: false,
        submitReviewed: false,
        submitRollBack:false,
      },
      form:{
        devTaskName:'',
        module:'',
        developerId:'',
      },
      formLabelWidth: '140px',
      currentPage: 1, // 当前页
      pageNo: 1,
      pageSize: 99999999,
      count: 0,
      formTaskInfo: '',
      dialogVisibleTask: false,
    }
  },
  computed: {
    ...mapState(
        {
          allSelect: (state) => state.devOps.ALLSELECT,
          allSystem: (state) => state.devOps.ALLSYSTEM,
          allUserList: (state) => state.devOps.ALLUSERLIST,
        }
    ),
  },
  async mounted() {
    this.$nextTick(async () => {
      /*await this.getTask();*/
      this.taskList.forEach((v, i) => {
        let result = this.checkedTestInfo.taskLists.find(obj => obj.sign === v.sign)
        if (result) {
          this.$refs.multipleTable.toggleRowSelection(v, true);
        }
      });
    })
  },
  async created() {
    // await this.getTask();
  },
  methods:{
    selectable(row, index) {
      if(row.developerId){
        return true;
      }else{
        return false;
      }
    },
    handleSelectionChange(val) {
      this.selectData = val;
    },
    rowselect(row) {
      if(row.developerId){
        this.$refs.multipleTable.toggleRowSelection(row);
      }
    },
    async  getTask(){
      const params = {...this.form,module: this.form.module.toString(),demandId:this.demand_id,pageNo:this.currentPage,pageSize:this.pageSize};
      await  getDevOpsSpaceFindDevelopTaskApi(params).then((res)=>{
        this.tableData = res.data;
        this.count = res.count;
      });
      let addData = this.addData;
      this.tableData.forEach((v, i) => {
        let result = addData.find(obj => obj.id === v.id)
        if (v.isChecked == 1 || result) {
          this.$refs.multipleTable.toggleRowSelection(v, true);
        }
      });
    },
    // 关闭弹窗
    handleClose() {
      if(this.back){
        this.hideDialogVisible('demand')
      }else{
        this.hideDialogVisible()
      }
    },
    // 分页
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
      this.getTask();
    },
    // 分页事件
    handleCurrentChange(val) {
      this.getTask();
    },
    async formSearch() {
      this.$emit('changeChoose',  this.form);
     /* if(type === 'reset'){
        this.pageNo = 1;
        this.currentPage = 1;
      }
      this.getTask();*/
    },
    confirmChoose(){
      if(!this.selectData.length){
        this.$notify({
          message: '请选择任务',
          type: "error",
        })
        return false;
      }
      this.getChooseTask({selectData:this.selectData,id:this.checkedTestInfo.id});
      this.handleClose();
    },
    linkToModel(row){
      let newRow = {...row,taskId:row.id};
      this.formTaskInfo = newRow;
      this.dialogVisibleTask = true;
    },
    handleTaskClose(){
      this.getTask();
      this.dialogVisibleTask = false;

    },
  }
}
</script>
<style lang="scss">
.table_text_click_new {
  text-decoration: underline;
  color: #409EFF;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

</style>
